import type { FunPaymentItem } from "../progress";

/** The canonical FunPaymentItem the web and server schema tests both parse. */
export const FUN_PAYMENT_ITEM_FIXTURE = {
  id: "3f2a6c1e-0000-4000-8000-000000000001",
  aliases: ["3f2a6c1e-0000-4000-8000-000000000001", "fun:CKX9d41"],
  entry: "card",
  method: "card",
  pairing: "exact",
  provisional: false,
  supportRef: "3f2a6c1e-0000-4000-8000-000000000001",
  steps: {
    submitted: { status: "done", at: "2026-10-20T10:00:00.000Z" },
    received: { status: "done", at: "2026-10-20T10:02:00.000Z" },
    sent: { status: "done", at: "2026-10-20T10:04:00.000Z" },
    available: { status: "active", at: null },
  },
  current: "available",
  state: "in_progress",
  retraction: null,
  awaitingBaseFinality: false,
  startedAt: "2026-10-20T10:00:00.000Z",
  updatedAt: "2026-10-20T10:04:00.000Z",
  deadlineAt: "2026-10-20T10:10:00.000Z",
  estimateMs: 300_000,
  amount: { requestedUsd: "50", paidOutUsdc: "49.41" },
  links: {
    origin: null,
    payout: { hash: "0x5721ad10000000000000000000000000000057a1" },
    delivery: null,
  },
  sentBy: "payout_tx",
  delivery: {
    id: "b7c3d2e1-0000-4000-8000-000000000002",
    destinationAssetKey: "usdc",
    stage: "pending",
    status: "PENDING",
    updatedAt: "2026-10-20T10:05:00.000Z",
    amountOutFormatted: "49.41",
    amountOutUsd: "49.41",
    withdrawFeeFormatted: "0.02",
    withdrawFeeUsd: "0.02",
    destinationTxHash: null,
    destinationSymbol: "USDC",
    destinationFaAddress: "0xf22bede236a0e13281d5afa0cfddba7b0b8c0e96e9c0e8337d1fc7f91e2c5b4d",
    destinationDecimals: 6,
    sweepable: false,
  },
  isDeliveryOwner: false,
  funRefundState: null,
  nextAction: "wait",
  dismissible: false,
  version: "v1",
} satisfies FunPaymentItem;
